import { Theme } from '@mui/material';
import { ChurnStatus } from '@shared/enums';

type ChurnStatusTheme = {
  background?: string;
  color?: string;
};

const churnStatusColourMapper = (theme: Theme): Record<ChurnStatus, ChurnStatusTheme> => ({
  [ChurnStatus.High]: {
    background: theme.palette.churnStatus?.high.main, 
    color: theme.palette.churnStatus?.high.contrastText,
  },
  [ChurnStatus.Moderate]: {
    background: theme.palette.churnStatus?.moderate.main, 
  },
  [ChurnStatus.Low]: {
    background: theme.palette.churnStatus?.low.main, 
    color: theme.palette.churnStatus?.low.contrastText,
  },
  [ChurnStatus.Insufficient]: {
    background: theme.palette.churnStatus?.insufficient.main, 
  },
  [ChurnStatus.NoRisk]: {
    background: 'none', 
  },
});

export const getChurnStatusColor = (status: ChurnStatus, theme: Theme): ChurnStatusTheme => {
  const ChurnStatusColourMapper = churnStatusColourMapper(theme);
  return ChurnStatusColourMapper[status] ?? ChurnStatusColourMapper[ChurnStatus.NoRisk];
};
